import { trpc } from '@/main'
import type { RootSearch } from '@/routes/__root'

/**
 * SINGLE SOURCE of the company `getOffersInfinite` input — used by both the loader prefetch and the
 * list component in the parallel Puestos (`isPosition: true`) and Ofertas (`isPosition: false`)
 * sections, so each section's prefetch and read share ONE cache key. Previously every loader hardcoded
 * `{ q: '', isPosition }` while the component built `{ q: searchQueryFromUrl, isPosition }`
 * independently, so a reload on a `?q=` deep link prefetched a different key than the component read
 * (wasted prefetch + client refetch). `q` defaults to `''` (root schema), so a cold load equals the
 * old hardcoded literal.
 */
export function companyOffersInput(search: Pick<RootSearch, 'q'>, isPosition: boolean) {
  return { q: search.q, isPosition } as const
}

export function companyOffersInfiniteQueryOptions(input: ReturnType<typeof companyOffersInput>) {
  return trpc.companies.getOffersInfinite.infiniteQueryOptions(input, {
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  })
}
